import request from '@/util/http'
import qs from 'qs'

// 主题列表查询
export const getTopicList=(params)=>request({
    url: '/admin/topic/page',
    method: 'get',
    params
})

// 专题单个删除
export const handleTopicDelete=(id)=>request({
    url: `/admin/topic/delete/${id}`,
    method: 'delete'
})
// 专题信息
export const getTopicInfo=(id)=>request({
    url: `/admin/topic/get/${id}`,
    method: 'get'
})

// 保存专题
export const hallSaveOrUpdate=(data)=>request({
        url: '/admin/topic/saveOrUpdate',
        method: 'post',
        data:qs.stringify(data)
    })
// 首页-办事服务列表
export const getTopicDlList=(params)=>request({
    url: '/admin/home/getServeList',
    method: 'get',
    params
})
// 首页-应用中心列表
export const getSubjectDlList=(params)=>request({
    url: '/admin/home/getAppList',
    method: 'get',
    params
})
// 首页-卡片列表
export const getCardList=(params)=>request({
    url: '/admin/home/getInformationList',
    method: 'get',
    params
})